module.exports = __webpack_public_path__ + "img/preferential-coupon.dae5e638.png";